import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import QuizWidget from '@/components/feature/QuizWidget';

export default function QuizPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-background-100">
        {/* Hero band */}
        <section className="relative overflow-hidden bg-brand-700">
          <div className="absolute inset-0 opacity-[0.04]"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.3'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          >
          </div>
          <div className="absolute inset-0 bg-gradient-to-br from-brand-800/90 via-brand-700/80 to-brand-600/60"></div>

          <div className="container-page relative z-10 py-16 md:py-20 text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-600/50 border border-brand-500/30 mb-5">
              <i className="ri-compass-3-line text-brand-200 text-xs"></i>
              <span className="text-xs font-medium text-brand-200 uppercase tracking-widest">
                30-Second Quiz
              </span>
            </div>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-paper-50 mb-4">
              Which Freshhlock Is Right for You?
            </h1>
            <p className="text-base md:text-lg text-brand-100/80 max-w-xl mx-auto leading-relaxed">
              Answer three quick questions and we&apos;ll point you to the pillar that fits your needs — processing, storage, transport, wholesale, or retail.
            </p>
          </div>
        </section>

        {/* Quiz widget */}
        <section className="py-16 md:py-24">
          <div className="container-page">
            <QuizWidget />
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}